import type { useTranslations } from "use-intl";
import { z } from "zod";

export const createValidationSchema = (t: ReturnType<typeof useTranslations>) =>
  z.object({
    tripDate: z.string().date(),
    travellers: z
      .object({
        adultInSingleRoom: z.number().min(0),
        adultInDoubleRoom: z.number().min(0),
        childWithBed: z.number().min(0),
        childWithoutBed: z.number().min(0),
        infant: z.number().min(0),
      })
      .refine(
        (travellers) =>
          travellers.adultInSingleRoom + travellers.adultInDoubleRoom >= 1,
        {
          message: t("trips.validation.atLeastOneAdult"),
          path: ["travellers"],
        },
      ),
    selectedTravellers: z.object({
      ADT: z
        .array(z.string().nullable())
        .min(1, t("trips.validation.atLeastOneAdult"))
        .readonly(),
      CHD: z.array(z.string().nullable()).readonly(),
      INF: z.array(z.string().nullable()).readonly(),
    }),
    termsAndConditions: z.literal<boolean>(true),
  });
